/** How a placed entity blocks the player (spec 2k §2). Pure: no Babylon import, so the upload panel can share it. */
export type ColliderMode = "mesh" | "box" | "none";

/** GLBs with more triangles than this collide as their bounding box, whatever was asked (spec 2k §2.2). */
export const MESH_COLLIDER_MAX_TRIANGLES = 20_000;

export interface Vec3 { x: number; y: number; z: number }
export interface Bounds { min: Vec3; max: Vec3 }

const MODES: readonly ColliderMode[] = ["mesh", "box", "none"];

/** collider.mode from an entity's components JSON; null when absent, malformed or not one of the three. */
export function requestedColliderMode(componentsJson: string): ColliderMode | null {
  try {
    const mode = (JSON.parse(componentsJson || "{}") as { collider?: { mode?: unknown } })?.collider?.mode;
    return MODES.includes(mode as ColliderMode) ? (mode as ColliderMode) : null;
  } catch {
    return null;
  }
}

/** Spec table 2.2: explicit box/none win; labels default to none; mesh falls back to box above the cap. */
export function resolveColliderMode(requested: ColliderMode | null, isLabel: boolean, triangles: number): ColliderMode {
  if (requested === "box" || requested === "none") return requested;
  if (requested === null && isLabel) return "none";
  return triangles > MESH_COLLIDER_MAX_TRIANGLES ? "box" : "mesh";
}
